module.exports = __webpack_public_path__ + "static/media/car_background@2x.3fbd26c5.jpg";